// extracted by mini-css-extract-plugin
export default {"button":"g2NDN","search":"QvJHo","scroll":"n3MVo","header":"w5VLQ","icon":"dStVb"};